module.exports = __webpack_public_path__ + "img/ceara.0d7dc3bd.jpg";